<template>
  <div class="app flex-row align-items-center loginbgnew">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <div class="text-center">
            <img
              class="mb-4"
              src="/images/brand-mark-white_1.svg"
              height="70"
              alt="ux.app Logo"
            />
          </div>
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form @submit.prevent="tryReset">
                  <h1>Forgot Password</h1>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend
                      ><b-input-group-text
                        ><i class="icon-user"/></b-input-group-text
                    ></b-input-group-prepend>
                    <b-form-input
                      v-model="user.email"
                      type="text"
                      class="form-control"
                      placeholder="Username"
                      autocomplete="username email"
                    />
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button variant="primary" type="submit" class="px-4">
                        Send Reset Email
                      </b-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <router-link class="btn btn-link" :to="'/login'">
                        Back To Login
                      </router-link>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
            <!--<b-card no-body class="text-white bg-primary py-5 d-md-down-none" style="width:44%">
              <b-card-body class="text-center">
                <div>
                  <h2>Sign up</h2>
                  <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                  <b-button variant="primary" class="active mt-3">Register Now!</b-button>
                </div>
              </b-card-body>
            </b-card>-->
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data: () => {
    return {
      user: {
        email: '',
        pass: ''
      }
    };
  },
  mounted() {
    this.isLogged();
  },
  methods: {
    isLogged() {
    },
    tryReset() {
      let $this = this;
      $this.$http
        .post('/api/auth/reset', {
          Email: this.user.email
        })
        .then(resp => {
          alert('Reset Email Sent!');
          setTimeout(() => {
            this.$router.push({ name: 'Dashboard' });
          }, 1000);
        })
        .catch(error => {
          console.log(error);
          alert('Cannot send reset email!');
        });
    }
  }
};
</script>
